export default function search(){
    const searchOpenButtons = document.querySelectorAll(".js-search-toggle");
    const searchOverlay = document.querySelector(".search-overlay");
    const searchCloseButton = document.querySelector(".search-overlay__close");
    const searchInput = document.getElementById("search-overlay-input");

    if(searchOpenButtons.length > 0 && searchOverlay && searchCloseButton){
        searchOpenButtons.forEach(button => {
            button.addEventListener("click", () => {
                searchOverlay.classList.add("is-active");
                setTimeout(() => {
                    searchInput.focus();
                }, 300);
            });
        });

        searchCloseButton.addEventListener("click", () => {
            searchOverlay.classList.remove("is-active");
        });

        document.addEventListener("keydown", function(event){
            if(event.key === "Escape"){
                searchOverlay.classList.remove("is-active");
            }
        });
    }
}